import { SagaMiddleware } from 'redux-saga'
import { sagas as invoiceSagas } from '../../../Routes/Invoices/store/invoices'

interface SagaMetadata {
  /* tslint:disable no-any */
  [_: string]: any
  /* tslint:enable no-any */
}

const sagas: SagaMetadata = {
  invoice: invoiceSagas
}

const registerWithMiddleware = (middleware: SagaMiddleware<{}>): void => {
  for (const name of Object.keys(sagas)) {
    middleware.run(sagas[name])
  }
}

export default registerWithMiddleware
